import createElement from "./createElement";

let fullPageLoadingOverlay = null;

/**
 * Creates a dom element for a full page loading overlay if not created yet
 */
function initFullPageLoading() {
    fullPageLoadingOverlay = document.querySelector('body > .full-page-loading-overlay');

    if (!fullPageLoadingOverlay) {
        fullPageLoadingOverlay = createElement(`
            <div class="full-page-loading-overlay loadable"></div>
        `)

        document.body.appendChild(fullPageLoadingOverlay);
    }
}

function addLoadableIfMissing(container) {
    if (!container.classList.contains('loadable')) {
        container.classList.add('loadable');
    }
}

function loading(container = null) {
    if (!container) {
        container = fullPageLoadingOverlay;
    }

    addLoadableIfMissing(container)

    container.classList.add('loading');
}

// Alias because window.loading is already taken in this project
function displayLoading(container = null){
    loading(container);
}

function stopLoading(container = null) {
    if (!container) {
        container = fullPageLoadingOverlay;
    }

    addLoadableIfMissing(container)

    container.classList.remove('loading');
}

function fullPageLoadingActive() {
    return fullPageLoadingOverlay && fullPageLoadingOverlay.classList.contains('loading');
}

export {
    initFullPageLoading,
    loading,
    displayLoading,
    stopLoading,
    fullPageLoadingActive
}
